import { request } from '@/utils/request'

/**
 * 查询沙盘存档（回显）
 * @param {{ userId: number|string, slot: string }} params
 */
export function getSandTableData (params) {
  return request('/zhima/psychology/getSandTableData', {
    method: 'GET',
    timeout: 60000,
    query: {
      userId: params.userId != null ? String(params.userId) : '',
      slot: params.slot != null ? String(params.slot) : ''
    }
  })
}

/**
 * 上传沙盘存档数据
 * @param {object} payload PsychologyInfoRequest
 */
export function uploadSandTableData (payload) {
  return request('/zhima/psychology/uploadSandTableData', {
    method: 'POST',
    body: payload
  })
}

/**
 * 删除沙盘存档
 * @param {{ userId: number|string, slot: string, time?: string }} params
 */
export function deleteTimeStatisData (params) {
  return request('/zhima/psychology/deleteTimeStatisData', {
    method: 'POST',
    body: {
      userId: params.userId,
      slot: params.slot,
      time: params.time || ''
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/psychology.js